import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpEvent,
  HttpContextToken,
  HttpHandlerFn
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TeamsService } from '../services/teams.service';
import { environment } from '../../environments/environment';

export const NO_TEAMS_TOKEN = new HttpContextToken<boolean>(() => false);

export const teamsInterceptorProvider = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const teamsService = inject(TeamsService);

  if (request.method !== 'GET' || request.context.get(NO_TEAMS_TOKEN)) {
    return next(request);
  }

  const teams = teamsService.teams;
  if (teams?.length && (request.url.includes(environment.apiUrl) || request.url.includes(environment.authUrl))) {
    const params = request.params.append('teams', teamsService.teams.toString());

    return next(request.clone({
      params: params
    }));
  }

  return next(request);
}
